module.exports = __webpack_public_path__ + "static/media/rhodes_0034_tremo.897283f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0034_tremo.jpg
// module id = 187
// module chunks = 0